/**
 * Collapses runs of whitespace into single spaces and trims leading/trailing whitespace.
 * Treats null and undefined as empty string.
 */
export function normalizeText(value: unknown): string {
  return String(value ?? '')
    .replace(/\s+/g, ' ')
    .trim();
}

/**
 * Converts a string to a lowercase dash-separated slug.
 * Expands & to " and " before collapsing non-alphanumerics into single dashes
 * (so "Fire & smoke" becomes "fire-and-smoke"). Trims leading/trailing dashes.
 * Returns null for empty or whitespace-only input.
 */
export function slugify(value: unknown): string | null {
  const normalized = normalizeText(value)
    .toLowerCase()
    .replace(/&/g, ' and ')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  return normalized || null;
}
